import * as ambassadorWixDataV2DataCollection from './data-v2-data-collection-collections.http.js';
import * as ambassadorWixDataV2DataCollectionTypes from './data-v2-data-collection-collections.types.js';
import * as ambassadorWixDataV2DataCollectionUniversalTypes from './data-v2-data-collection-collections.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createDataCollection(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDataV2DataCollectionUniversalTypes.CreateDataCollectionRequest,
  ambassadorWixDataV2DataCollectionTypes.CreateDataCollectionRequest,
  ambassadorWixDataV2DataCollectionUniversalTypes.CreateDataCollectionResponse,
  ambassadorWixDataV2DataCollectionTypes.CreateDataCollectionResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDataV2DataCollection.createDataCollection(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/collections',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getDataCollection(): __PublicMethodMetaInfo<
  'GET',
  { dataCollectionId: string },
  ambassadorWixDataV2DataCollectionUniversalTypes.GetDataCollectionRequest,
  ambassadorWixDataV2DataCollectionTypes.GetDataCollectionRequest,
  ambassadorWixDataV2DataCollectionUniversalTypes.GetDataCollectionResponse,
  ambassadorWixDataV2DataCollectionTypes.GetDataCollectionResponse
> {
  const payload = { dataCollectionId: ':dataCollectionId' } as any;

  const getRequestOptions =
    ambassadorWixDataV2DataCollection.getDataCollection(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/collections/{dataCollectionId}',
    pathParams: { dataCollectionId: 'dataCollectionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listDataCollections(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixDataV2DataCollectionUniversalTypes.ListDataCollectionsRequest,
  ambassadorWixDataV2DataCollectionTypes.ListDataCollectionsRequest,
  ambassadorWixDataV2DataCollectionUniversalTypes.ListDataCollectionsResponse,
  ambassadorWixDataV2DataCollectionTypes.ListDataCollectionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDataV2DataCollection.listDataCollections(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/collections',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateDataCollection(): __PublicMethodMetaInfo<
  'PUT',
  {},
  ambassadorWixDataV2DataCollectionUniversalTypes.UpdateDataCollectionRequest,
  ambassadorWixDataV2DataCollectionTypes.UpdateDataCollectionRequest,
  ambassadorWixDataV2DataCollectionUniversalTypes.UpdateDataCollectionResponse,
  ambassadorWixDataV2DataCollectionTypes.UpdateDataCollectionResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDataV2DataCollection.updateDataCollection(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PUT',
    path: '/v2/collections',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteDataCollection(): __PublicMethodMetaInfo<
  'DELETE',
  { dataCollectionId: string },
  ambassadorWixDataV2DataCollectionUniversalTypes.DeleteDataCollectionRequest,
  ambassadorWixDataV2DataCollectionTypes.DeleteDataCollectionRequest,
  ambassadorWixDataV2DataCollectionUniversalTypes.DeleteDataCollectionResponse,
  ambassadorWixDataV2DataCollectionTypes.DeleteDataCollectionResponse
> {
  const payload = { dataCollectionId: ':dataCollectionId' } as any;

  const getRequestOptions =
    ambassadorWixDataV2DataCollection.deleteDataCollection(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v2/collections/{dataCollectionId}',
    pathParams: { dataCollectionId: 'dataCollectionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function restoreDataCollection(): __PublicMethodMetaInfo<
  'POST',
  { dataCollectionId: string },
  ambassadorWixDataV2DataCollectionUniversalTypes.RestoreDataCollectionRequest,
  ambassadorWixDataV2DataCollectionTypes.RestoreDataCollectionRequest,
  ambassadorWixDataV2DataCollectionUniversalTypes.RestoreDataCollectionResponse,
  ambassadorWixDataV2DataCollectionTypes.RestoreDataCollectionResponse
> {
  const payload = { dataCollectionId: ':dataCollectionId' } as any;

  const getRequestOptions =
    ambassadorWixDataV2DataCollection.restoreDataCollection(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/collections/restore/{dataCollectionId}',
    pathParams: { dataCollectionId: 'dataCollectionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function patchDataCollection(): __PublicMethodMetaInfo<
  'PATCH',
  { dataCollectionId: string },
  ambassadorWixDataV2DataCollectionUniversalTypes.PatchDataCollectionRequest,
  ambassadorWixDataV2DataCollectionTypes.PatchDataCollectionRequest,
  ambassadorWixDataV2DataCollectionUniversalTypes.PatchDataCollectionResponse,
  ambassadorWixDataV2DataCollectionTypes.PatchDataCollectionResponse
> {
  const payload = { dataCollection: { id: ':dataCollectionId' } } as any;

  const getRequestOptions =
    ambassadorWixDataV2DataCollection.patchDataCollection(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v2/collections/{dataCollection.id}',
    pathParams: { dataCollectionId: 'dataCollectionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createDataCollectionField(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDataV2DataCollectionUniversalTypes.CreateDataCollectionFieldRequest,
  ambassadorWixDataV2DataCollectionTypes.CreateDataCollectionFieldRequest,
  ambassadorWixDataV2DataCollectionUniversalTypes.CreateDataCollectionFieldResponse,
  ambassadorWixDataV2DataCollectionTypes.CreateDataCollectionFieldResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDataV2DataCollection.createDataCollectionField(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/collections/create-field',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateDataCollectionField(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDataV2DataCollectionUniversalTypes.UpdateDataCollectionFieldRequest,
  ambassadorWixDataV2DataCollectionTypes.UpdateDataCollectionFieldRequest,
  ambassadorWixDataV2DataCollectionUniversalTypes.UpdateDataCollectionFieldResponse,
  ambassadorWixDataV2DataCollectionTypes.UpdateDataCollectionFieldResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDataV2DataCollection.updateDataCollectionField(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/collections/update-field',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteDataCollectionField(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDataV2DataCollectionUniversalTypes.DeleteDataCollectionFieldRequest,
  ambassadorWixDataV2DataCollectionTypes.DeleteDataCollectionFieldRequest,
  ambassadorWixDataV2DataCollectionUniversalTypes.DeleteDataCollectionFieldResponse,
  ambassadorWixDataV2DataCollectionTypes.DeleteDataCollectionFieldResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDataV2DataCollection.deleteDataCollectionField(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/collections/delete-field',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function addDataCollectionPlugin(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDataV2DataCollectionUniversalTypes.AddDataCollectionPluginRequest,
  ambassadorWixDataV2DataCollectionTypes.AddDataCollectionPluginRequest,
  ambassadorWixDataV2DataCollectionUniversalTypes.AddDataCollectionPluginResponse,
  ambassadorWixDataV2DataCollectionTypes.AddDataCollectionPluginResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDataV2DataCollection.addDataCollectionPlugin(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/collections/add-plugin',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteDataCollectionPlugin(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDataV2DataCollectionUniversalTypes.DeleteDataCollectionPluginRequest,
  ambassadorWixDataV2DataCollectionTypes.DeleteDataCollectionPluginRequest,
  ambassadorWixDataV2DataCollectionUniversalTypes.DeleteDataCollectionPluginResponse,
  ambassadorWixDataV2DataCollectionTypes.DeleteDataCollectionPluginResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDataV2DataCollection.deleteDataCollectionPlugin(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/collections/delete-plugin',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function patchDataCollectionField(): __PublicMethodMetaInfo<
  'PATCH',
  { dataCollectionId: string },
  ambassadorWixDataV2DataCollectionUniversalTypes.PatchDataCollectionFieldRequest,
  ambassadorWixDataV2DataCollectionTypes.PatchDataCollectionFieldRequest,
  ambassadorWixDataV2DataCollectionUniversalTypes.PatchDataCollectionFieldResponse,
  ambassadorWixDataV2DataCollectionTypes.PatchDataCollectionFieldResponse
> {
  const payload = { dataCollectionId: ':dataCollectionId' } as any;

  const getRequestOptions =
    ambassadorWixDataV2DataCollection.patchDataCollectionField(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v2/collections/{dataCollectionId}/patch-field',
    pathParams: { dataCollectionId: 'dataCollectionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  DataCollection as DataCollectionOriginal,
  CollectionType as CollectionTypeOriginal,
  CollectionTypeWithLiterals as CollectionTypeWithLiteralsOriginal,
  Sort as SortOriginal,
  Direction as DirectionOriginal,
  DirectionWithLiterals as DirectionWithLiteralsOriginal,
  CollectionCapabilities as CollectionCapabilitiesOriginal,
  DataOperation as DataOperationOriginal,
  DataOperationWithLiterals as DataOperationWithLiteralsOriginal,
  CollectionOperation as CollectionOperationOriginal,
  CollectionOperationWithLiterals as CollectionOperationWithLiteralsOriginal,
  IndexLimits as IndexLimitsOriginal,
  IndexQuotaLimits as IndexQuotaLimitsOriginal,
  Field as FieldOriginal,
  FieldRangeValidationsOneOf as FieldRangeValidationsOneOfOriginal,
  TextValidation as TextValidationOriginal,
  EnumValues as EnumValuesOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  TypeMetadata as TypeMetadataOriginal,
  TypeMetadataMetadataOneOf as TypeMetadataMetadataOneOfOriginal,
  FieldCapabilities as FieldCapabilitiesOriginal,
  QueryOperator as QueryOperatorOriginal,
  QueryOperatorWithLiterals as QueryOperatorWithLiteralsOriginal,
  ObjectField as ObjectFieldOriginal,
  FieldsPattern as FieldsPatternOriginal,
  UrlizedOnlyPattern as UrlizedOnlyPatternOriginal,
  Calculator as CalculatorOriginal,
  CalculatorPatternOneOf as CalculatorPatternOneOfOriginal,
  PageLinkType as PageLinkTypeOriginal,
  PageLinkTypeWithLiterals as PageLinkTypeWithLiteralsOriginal,
  Reference as ReferenceOriginal,
  MultiReference as MultiReferenceOriginal,
  _Object as _ObjectOriginal,
  _Array as _ArrayOriginal,
  PageLink as PageLinkOriginal,
  Slug as SlugOriginal,
  Text as TextOriginal,
  TextValidationOneOf as TextValidationOneOfOriginal,
  _Number as _NumberOriginal,
  _Date as _DateOriginal,
  _DateDefaultValueOneOf as _DateDefaultValueOneOfOriginal,
  _DateMinDateOneOf as _DateMinDateOneOfOriginal,
  _DateMaxDateOneOf as _DateMaxDateOneOfOriginal,
  Datetime as DatetimeOriginal,
  DatetimeDefaultValueOneOf as DatetimeDefaultValueOneOfOriginal,
  DatetimeMinDateOneOf as DatetimeMinDateOneOfOriginal,
  DatetimeMaxDateOneOf as DatetimeMaxDateOneOfOriginal,
  Image as ImageOriginal,
  _Boolean as _BooleanOriginal,
  Document as DocumentOriginal,
  Url as UrlOriginal,
  RichText as RichTextOriginal,
  Video as VideoOriginal,
  ArrayString as ArrayStringOriginal,
  ArrayDocument as ArrayDocumentOriginal,
  Audio as AudioOriginal,
  Time as TimeOriginal,
  RichContent as RichContentOriginal,
  MediaGallery as MediaGalleryOriginal,
  Address as AddressOriginal,
  Email as EmailOriginal,
  LegacyColor as LegacyColorOriginal,
  NumberRange as NumberRangeOriginal,
  StringLengthRange as StringLengthRangeOriginal,
  ArraySizeRange as ArraySizeRangeOriginal,
  FieldPlugin as FieldPluginOriginal,
  FieldPluginOptionsOneOf as FieldPluginOptionsOneOfOriginal,
  FieldPluginType as FieldPluginTypeOriginal,
  FieldPluginTypeWithLiterals as FieldPluginTypeWithLiteralsOriginal,
  CmsOptions as CmsOptionsOriginal,
  CategoryFieldOptions as CategoryFieldOptionsOriginal,
  FieldCondition as FieldConditionOriginal,
  Permission as PermissionOriginal,
  PermissionWithLiterals as PermissionWithLiteralsOriginal,
  Permissions as PermissionsOriginal,
  Role as RoleOriginal,
  RoleWithLiterals as RoleWithLiteralsOriginal,
  Plugin as PluginOriginal,
  PluginOptionsOneOf as PluginOptionsOneOfOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  Format as FormatOriginal,
  FormatWithLiterals as FormatWithLiteralsOriginal,
  SiteSort as SiteSortOriginal,
  PluginType as PluginTypeOriginal,
  PluginTypeWithLiterals as PluginTypeWithLiteralsOriginal,
  PublishPluginOptions as PublishPluginOptionsOriginal,
  SingleItemPluginOptions as SingleItemPluginOptionsOriginal,
  UrlizedPluginOptions as UrlizedPluginOptionsOriginal,
  MultilingualOptions as MultilingualOptionsOriginal,
  PageLinkPluginOptions as PageLinkPluginOptionsOriginal,
  PluginCmsOptions as PluginCmsOptionsOriginal,
  CatalogOptions as CatalogOptionsOriginal,
  PagingMode as PagingModeOriginal,
  PagingModeWithLiterals as PagingModeWithLiteralsOriginal,
  DataPermissions as DataPermissionsOriginal,
  AccessLevel as AccessLevelOriginal,
  AccessLevelWithLiterals as AccessLevelWithLiteralsOriginal,
  AllowedDataPermissions as AllowedDataPermissionsOriginal,
  DataCollectionClonedEvent as DataCollectionClonedEventOriginal,
  DataCollectionChangedEvent as DataCollectionChangedEventOriginal,
  FieldUpdate as FieldUpdateOriginal,
  PluginUpdate as PluginUpdateOriginal,
  PermissionsUpdate as PermissionsUpdateOriginal,
  StrictModeUpdate as StrictModeUpdateOriginal,
  DataCollectionEvictedEvent as DataCollectionEvictedEventOriginal,
  CreateDataCollectionRequest as CreateDataCollectionRequestOriginal,
  CreateDataCollectionResponse as CreateDataCollectionResponseOriginal,
  GetDataCollectionRequest as GetDataCollectionRequestOriginal,
  Segment as SegmentOriginal,
  SegmentWithLiterals as SegmentWithLiteralsOriginal,
  GetDataCollectionResponse as GetDataCollectionResponseOriginal,
  ListDataCollectionsRequest as ListDataCollectionsRequestOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Paging as PagingOriginal,
  ListDataCollectionsResponse as ListDataCollectionsResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  BulkGetDataCollectionsRequest as BulkGetDataCollectionsRequestOriginal,
  BulkGetDataCollectionsResponse as BulkGetDataCollectionsResponseOriginal,
  ApplicationError as ApplicationErrorOriginal,
  FailedCollection as FailedCollectionOriginal,
  UpdateDataCollectionRequest as UpdateDataCollectionRequestOriginal,
  UpdateDataCollectionResponse as UpdateDataCollectionResponseOriginal,
  DeleteDataCollectionRequest as DeleteDataCollectionRequestOriginal,
  DeleteDataCollectionResponse as DeleteDataCollectionResponseOriginal,
  RestoreDataCollectionRequest as RestoreDataCollectionRequestOriginal,
  RestoreDataCollectionResponse as RestoreDataCollectionResponseOriginal,
  PatchDataCollectionRequest as PatchDataCollectionRequestOriginal,
  PatchDataCollectionResponse as PatchDataCollectionResponseOriginal,
  CreateDataCollectionFieldRequest as CreateDataCollectionFieldRequestOriginal,
  CreateDataCollectionFieldResponse as CreateDataCollectionFieldResponseOriginal,
  UpdateDataCollectionFieldRequest as UpdateDataCollectionFieldRequestOriginal,
  UpdateDataCollectionFieldResponse as UpdateDataCollectionFieldResponseOriginal,
  DeleteDataCollectionFieldRequest as DeleteDataCollectionFieldRequestOriginal,
  DeleteDataCollectionFieldResponse as DeleteDataCollectionFieldResponseOriginal,
  AddDataCollectionPluginRequest as AddDataCollectionPluginRequestOriginal,
  AddDataCollectionPluginResponse as AddDataCollectionPluginResponseOriginal,
  DeleteDataCollectionPluginRequest as DeleteDataCollectionPluginRequestOriginal,
  DeleteDataCollectionPluginResponse as DeleteDataCollectionPluginResponseOriginal,
  PatchDataCollectionFieldRequest as PatchDataCollectionFieldRequestOriginal,
  PatchDataCollectionFieldResponse as PatchDataCollectionFieldResponseOriginal,
  UpdateDataPermissionsRequest as UpdateDataPermissionsRequestOriginal,
  UpdateDataPermissionsResponse as UpdateDataPermissionsResponseOriginal,
  BulkGetDataCollectionsPageBySnapshotsRequest as BulkGetDataCollectionsPageBySnapshotsRequestOriginal,
  BulkGetDataCollectionsPageBySnapshotsRequestTenantModeOptionsOneOf as BulkGetDataCollectionsPageBySnapshotsRequestTenantModeOptionsOneOfOriginal,
  TenantMode as TenantModeOriginal,
  TenantModeWithLiterals as TenantModeWithLiteralsOriginal,
  AppOptions as AppOptionsOriginal,
  BulkGetDataCollectionsPageBySnapshotsResponse as BulkGetDataCollectionsPageBySnapshotsResponseOriginal,
  SnapshotCollection as SnapshotCollectionOriginal,
  Index as IndexOriginal,
  Order as OrderOriginal,
  OrderWithLiterals as OrderWithLiteralsOriginal,
  IndexField as IndexFieldOriginal,
  IndexStatus as IndexStatusOriginal,
  IndexStatusWithLiterals as IndexStatusWithLiteralsOriginal,
  Failure as FailureOriginal,
  IndexSource as IndexSourceOriginal,
  IndexSourceWithLiterals as IndexSourceWithLiteralsOriginal,
  CreateDataCollectionsSnapshotRequest as CreateDataCollectionsSnapshotRequestOriginal,
  CreateDataCollectionsSnapshotResponse as CreateDataCollectionsSnapshotResponseOriginal,
  CreateAppCollectionsSnapshotRequest as CreateAppCollectionsSnapshotRequestOriginal,
  CollectionDefinition as CollectionDefinitionOriginal,
  CreateAppCollectionsSnapshotResponse as CreateAppCollectionsSnapshotResponseOriginal,
  RestoreDataCollectionsFromSnapshotRequest as RestoreDataCollectionsFromSnapshotRequestOriginal,
  Destination as DestinationOriginal,
  RestorationCollection as RestorationCollectionOriginal,
  RestoreDataCollectionsFromSnapshotResponse as RestoreDataCollectionsFromSnapshotResponseOriginal,
  DeleteDataCollectionsSnapshotRequest as DeleteDataCollectionsSnapshotRequestOriginal,
  DeleteDataCollectionsSnapshotResponse as DeleteDataCollectionsSnapshotResponseOriginal,
  CreateMigratedCollectionsSnapshotRequest as CreateMigratedCollectionsSnapshotRequestOriginal,
  CreateMigratedCollectionsSnapshotResponse as CreateMigratedCollectionsSnapshotResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './data-v2-data-collection-collections.types.js';
